function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".favorite_store_remove{fill:#6c6c6c;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "favorite_store_remove",
  d: "M128.85,46.47a15.28,15.28,0,0,0-14.48-10.55H88.21a.84.84,0,0,1-.82-.58L79.31,10.46a15.26,15.26,0,0,0-29,0L42.22,35.34a.79.79,0,0,1-.8.58H15.29a15.25,15.25,0,0,0-9,27.61L27.47,78.9a.84.84,0,0,1,.29.94L19.7,104.7a15.21,15.21,0,0,0,23.46,17L64.3,106.39a.8.8,0,0,1,1,0l21.14,15.35a15.25,15.25,0,0,0,23.48-17l-8.08-24.86a.85.85,0,0,1,.31-1l21.17-15.37A15.26,15.26,0,0,0,128.85,46.47Z",
  transform: "translate(0 0)"
});

var SvgFavoriteStoreRemove = function SvgFavoriteStoreRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    viewBox: "0 0 129.6 124.71",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFavoriteStoreRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/favorite_store_remove.ecb80c55.svg";
export { ForwardRef as ReactComponent };